<template>
  <div ref="loaderTarget" class="d-flex w-100 my-5">
    <div class="m-auto spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <span class="mx-3">{{ spinnerLabel }}</span>
  </div>
</template>

<script>
export default {
  props: ["options", "loadMore", "spinnerLabel"],
  data() {
    return {
      observer: null,
    };
  },
  methods: {
    callback(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore();
        }
      });
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(this.callback, this.options);
    this.observer.observe(this.$refs.loaderTarget);
  },
  beforeDestroy() {
    this.observer.unobserve(this.$refs.loaderTarget);
  }
};
</script>

<style>
</style>